"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopPagesCard = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _Truncate = _interopRequireDefault(require("../Truncate"));
var _excluded = ["url", "title", "text", "linkClassName", "textClassName", "maxTitleLines", "maxTextLines", "thumbnail", "hideImage", "hideDescription", "externalUrl"];
var __jsx = _react.default.createElement;
var FALLBACK_IMAGE_URL = '/deepweb/assets/sigmaaldrich/marketing/global/images/default/default-link-image/default-link-image.png';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _text, _link, _linkContainer;
  return {
    text: (_text = {
      lineHeight: theme.typography.pxToRem(16),
      fontSize: theme.typography.pxToRem(14),
      display: 'block'
    }, (0, _defineProperty2.default)(_text, theme.breakpoints.up('md'), {
      lineHeight: theme.typography.pxToRem(22),
      paddingTop: theme.spacing(1),
      fontSize: theme.typography.pxToRem(16)
    }), (0, _defineProperty2.default)(_text, '.aem-Grid--default--3 &, .aem-Grid--default--4 &', (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16)
    })), _text),
    link: (_link = {
      color: 'inherit',
      fontSize: theme.typography.pxToRem(14),
      marginBottom: theme.spacing(0),
      fontWeight: theme.typography.fontWeightBold
    }, (0, _defineProperty2.default)(_link, theme.breakpoints.up('md'), {
      fontSize: theme.typography.pxToRem(16),
      marginBottom: theme.spacing(0.5)
    }), (0, _defineProperty2.default)(_link, theme.breakpoints.down('xs'), {
      fontSize: theme.typography.pxToRem(12),
      marginBottom: theme.spacing(0.5)
    }), (0, _defineProperty2.default)(_link, '.aem-Grid--default--3 &, .aem-Grid--default--4 &', (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), {
      fontSize: theme.typography.pxToRem(14)
    })), _link),
    imageHeight: (0, _defineProperty2.default)({
      position: 'relative',
      background: 'transparent',
      width: '100px',
      height: '100px',
      marginLeft: 'auto',
      marginRight: 'auto',
      textAlign: 'end'
    }, theme.breakpoints.down('xs'), {
      width: '64px',
      height: '64px'
    }),
    imgResponsive: {
      width: '100%',
      objectFit: 'cover'
    },
    linkContainer: (_linkContainer = {
      lineHeight: theme.typography.pxToRem(16)
    }, (0, _defineProperty2.default)(_linkContainer, theme.breakpoints.up('md'), {
      lineHeight: theme.typography.pxToRem(24)
    }), (0, _defineProperty2.default)(_linkContainer, '.aem-Grid--default--3 &, .aem-Grid--default--4 &', (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), {
      lineHeight: theme.typography.pxToRem(16)
    })), _linkContainer),
    videoPlayCircle: {
      position: 'absolute',
      height: '75%',
      width: '100%',
      top: '12.5%',
      color: theme.palette.common.white,
      opacity: '50%'
    }
  };
});
var TopPagesCard = function TopPagesCard(_ref) {
  var url = _ref.url,
    title = _ref.title,
    text = _ref.text,
    _ref$linkClassName = _ref.linkClassName,
    linkClassName = _ref$linkClassName === void 0 ? '' : _ref$linkClassName,
    textClassName = _ref.textClassName,
    _ref$maxTitleLines = _ref.maxTitleLines,
    maxTitleLines = _ref$maxTitleLines === void 0 ? 1 : _ref$maxTitleLines,
    _ref$maxTextLines = _ref.maxTextLines,
    maxTextLines = _ref$maxTextLines === void 0 ? 2 : _ref$maxTextLines,
    thumbnail = _ref.thumbnail,
    _ref$hideImage = _ref.hideImage,
    hideImage = _ref$hideImage === void 0 ? true : _ref$hideImage,
    _ref$hideDescription = _ref.hideDescription,
    hideDescription = _ref$hideDescription === void 0 ? false : _ref$hideDescription,
    _ref$externalUrl = _ref.externalUrl,
    externalUrl = _ref$externalUrl === void 0 ? false : _ref$externalUrl,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var classes = useStyles();
  return __jsx(_react.default.Fragment, null, !hideImage && __jsx(_react.default.Fragment, null, url && __jsx("div", {
    className: classes.imageHeight
  }, __jsx("img", {
    src: thumbnail,
    className: classes.imgResponsive,
    alt: props.imgAltText || title,
    title: title,
    onError: function onError(e) {
      var target = e.currentTarget;
      if (target.src !== FALLBACK_IMAGE_URL) {
        target.src = FALLBACK_IMAGE_URL;
      }
    }
  }))), url && title && __jsx("div", {
    className: classes.linkContainer
  }, __jsx(_Truncate.default, {
    lines: maxTitleLines,
    lineHeight: 1.19
  }, __jsx(_core.Typography, {
    className: classes.link,
    component: "span",
    dangerouslySetInnerHTML: {
      __html: title
    }
  }))), !hideDescription && __jsx(_react.default.Fragment, null, text && __jsx(_Truncate.default, {
    lines: maxTextLines,
    lineHeight: 0.5
  }, __jsx(_core.Typography, {
    className: classes.text,
    component: "span",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }))));
};
exports.TopPagesCard = TopPagesCard;